module.exports = __webpack_public_path__ + "img/manager.e7bdb7e8.png";